import React from 'react';
import {
    Container,
    Typography,
    Box,
    Paper,
    Button
} from '@mui/material';
import { BookmarkBorder, Construction } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const Bookmarks = () => {
    const navigate = useNavigate();

    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Paper 
                elevation={1} 
                sx={{ 
                    p: 6, 
                    textAlign: 'center',
                    borderRadius: 3
                }}
            >
                <Construction 
                    sx={{ 
                        fontSize: 80, 
                        color: 'primary.main', 
                        mb: 2 
                    }} 
                />
                <Typography 
                    variant="h3" 
                    gutterBottom 
                    sx={{ 
                        fontWeight: 600,
                        color: 'primary.main',
                        mb: 2
                    }}
                >
                    Bookmarks
                </Typography>
                <Typography 
                    variant="h6" 
                    color="text.secondary" 
                    paragraph
                    sx={{ mb: 4 }}
                >
                    Save your favorite stories and posts here for easy access later.
                </Typography>
                <Typography 
                    variant="body1" 
                    color="text.secondary" 
                    paragraph
                    sx={{ mb: 4 }}
                >
                    This feature is currently under development and will be available soon!
                </Typography>
                
                <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                    <Button
                        variant="contained"
                        startIcon={<BookmarkBorder />}
                        onClick={() => navigate('/short-stories')}
                        sx={{
                            textTransform: 'none',
                            fontWeight: 600,
                            px: 3,
                            py: 1.5
                        }}
                    >
                        Browse Stories
                    </Button>
                    <Button
                        variant="outlined"
                        onClick={() => navigate('/profile')}
                        sx={{
                            textTransform: 'none',
                            fontWeight: 600,
                            px: 3,
                            py: 1.5
                        }}
                    >
                        Back to Home
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
};

export default Bookmarks; 